import React from 'react';
export function AppendixSidewalkSlide() {
  return <section className="slide" style={{
    backgroundColor: '#0d1520'
  }} data-id="element-106">
      <div className="flex flex-col w-full h-full min-h-0" data-id="element-107">
        {/* Top Panel */}
        <div className="flex flex-col justify-center w-full flex-shrink-0 min-h-0" style={{
        padding: 'clamp(1.5rem, 3vw, 2.5rem) var(--slide-padding) 0'
      }} data-id="element-108">
          <div className="flex items-baseline gap-4 mb-[clamp(0.5rem,1vw,1rem)] animate-fade-slide" style={{
          animationDelay: '0.1s'
        }} data-id="element-109">
            <p className="italic font-semibold" style={{
            color: '#4A90D9',
            fontSize: 'var(--body-size)'
          }} data-id="element-110">
              Experiment 06
            </p>
            <h2 className="font-black tracking-tight text-white leading-[1.1]" style={{
            fontSize: 'var(--h2-size)'
          }} data-id="element-111">
              Sidewalk inference from satellite imagery
            </h2>
          </div>
          <p className="text-white/70 leading-relaxed animate-fade-slide max-w-5xl" style={{
          fontSize: 'var(--body-size)',
          animationDelay: '0.2s'
        }} data-id="element-112">
            Training a two-stage model on satellite imagery fused with
            pedestrian activity signals and road geometry to detect sidewalk
            presence. Structured sidewalk data basically doesn't exist for most
            cities. Early runs on Phoenix, São Paulo, and Lexington.{' '}
            <span className="text-white font-medium" data-id="element-113">
              If this works at scale it fills a gap no one else is addressing.
            </span>
          </p>
        </div>

        {/* Bottom Panel */}
        <div className="flex-1 flex items-center justify-center p-[var(--slide-padding)] min-h-0 relative" data-id="element-114">
          <div className="w-full h-full relative rounded-xl overflow-hidden animate-fade-slide" style={{
          animationDelay: '0.3s'
        }} data-id="element-115">
            <img src="https://cdn.magicpatterns.com/uploads/eAKWH4HfaZRUaMbWp51asF/Sidewalk_inference1.png" alt="Sidewalk inference from satellite imagery" className="absolute inset-0 w-full h-full object-cover rounded-xl" style={{
            boxShadow: '0 20px 40px rgba(0,0,0,0.4)'
          }} data-id="element-116" />
          </div>
        </div>
      </div>
    </section>;
}